import { cva } from 'class-variance-authority';

/**
 * Menu status class recipes. Colour comes from the `--ds-menu-status-*` slots on `.ds-menu-status`
 * in `design-system.css`, so there is no `dark:` variant here.
 *
 * Ported from Figma `Menu Status`, page `Menu status [Draft]` (set 2106:152912), read 2026-09-29.
 * Three kinds, each 112px tall: three 36px menu rows plus the two 2px gaps between them, so a popup
 * does not change height when its options arrive. 112 is not a step on the spacing scale (which
 * stops at 64), so it is written as the value it is. Loading and empty grow only if their copy wraps.
 *
 * No timing utility of its own: the delayed ring is `Spinner`'s and the pulse is `Skeleton`'s. The
 * empty kind is static, and does not animate in, for the reason `EmptyState` records.
 */
export const menuStatusRecipe = cva('ds-menu-status box-border flex min-h-[112px] w-full min-w-0 flex-col font-sans', {
  variants: {
    kind: {
      // Left-aligned like a menu row; the row is centred in the 112px.
      loading: 'justify-center px-3 py-2',
      // Rows are flush with the panel's own padding, and 2px apart like real rows.
      skeleton: 'gap-[2px]',
      empty: 'items-center justify-center gap-1 px-6 py-4 text-center',
    },
  },
});

/** One 36px placeholder row: x3 across, 10px down around the 16px bar. */
export const menuStatusSkeletonRowRecipe = cva('flex h-9 items-center px-3', {
  variants: {
    // The bars end at different distances from the right edge so they read as text of different lengths.
    line: { first: 'pr-3', second: 'pr-16', third: 'pr-10' },
  },
});

export const menuStatusTitleRecipe = cva(
  'text-heading-xs m-0 min-w-0 text-balance text-[var(--ds-menu-status-title)] [overflow-wrap:anywhere]'
);

export const menuStatusDescriptionRecipe = cva(
  'text-body-md m-0 min-w-0 text-balance text-[var(--ds-menu-status-description)] [overflow-wrap:anywhere]'
);
